import { render, staticRenderFns } from "./StatsOrder.vue?vue&type=template&id=71d199c1"
import script from "./StatsOrder.vue?vue&type=script&lang=js"
export * from "./StatsOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports